<template>
    <v-form autocomplete="off" class="fill-height">
        <v-card class="fill-height d-flex flex-column">
            <v-toolbar dark color="primary" flat style="max-height: 64px;">
                <v-toolbar-title>Schedule EDN?</v-toolbar-title>
                <slot name="header"></slot>
            </v-toolbar>
            <v-card-text class="flex-grow-1">
                <v-container grid-list-md>
                    <v-row>
                        <v-col>
                            <p class="subtitle-1">Would you like to schedule the remaining incomplete defects now?</p>
                            <p class="subtitle-1">If later, scheduling must be completed within 24 hours.</p>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <slot name="actions"></slot>
                <v-btn @click="scheduleLater">Later</v-btn>
                <v-btn color="primary" @click="scheduleNow">Schedule Now</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
export default {
    props: {
        model: {
            required: true
        }
    },
    methods: {
        scheduleLater() {
            this.$emit('schedule-later');
        },
        scheduleNow() {
            this.$emit('schedule-now', this.model);
        }
    }
};
</script>
